import { SEVERITY } from "helpers/utils.js";
import {
  GET_STORE,
  GET_STORE_SUCCESS,
  GET_STORE_FAIL,
  GET_STORE_BY_ID_SUCCESS,
  ADD_NEW_STORE,
  ADD_NEW_STORE_SUCCESS,
  UPDATE_STORE,
  UPDATE_STORE_SUCCESS,
  DELETE_STORE,
  DELETE_STORE_SUCCESS,
  STORE_CLEAR_NOTIFY,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
  message: null,
};

const store = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_NEW_STORE:
    case UPDATE_STORE:
    case DELETE_STORE:
    case GET_STORE:
      return {
        ...state,
        loading: true,
      };
    case GET_STORE_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_STORE_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };

    case ADD_NEW_STORE_SUCCESS:
      return {
        ...state,
        message: {
          title: "Store",
          text: "Store has been added successfully.",
          severity: SEVERITY.INFO,
        },
      };
    case UPDATE_STORE_SUCCESS:
      return {
        ...state,
        message: {
          title: "Store",
          text: "Store has been updated successfully.",
          severity: SEVERITY.INFO,
        },
      };
    case DELETE_STORE_SUCCESS:
      return {
        ...state,
        message: {
          title: "Store",
          text: "Store has been deleted successfully.",
          severity: SEVERITY.INFO,
        },
      };
    case GET_STORE_FAIL:
      return {
        ...state,
        error: payload,
      };
    case STORE_CLEAR_NOTIFY:
      return {
        ...state,
        message: null,
      };
    default:
      return state;
  }
};

export default store;
